import { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import $ from "jquery";
import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../../layout/MainArea";
import { getDataTableDom, requestToServer } from "../../../utils/appUtils";
import TableDT from "../../../UI/TableDT";
import CardMCConn from "./cardMCConn";

function McConnect(props) {
    clearInterval(window.timer)
    let butchState = localStorage.getItem('mccon') === undefined ? true : localStorage.getItem('mccon') === "false" ? false : true;

    // if (serverData === null)
    //     return <MainArea loading />;

    return (
        <>
            <MainArea>
                <MainAreaBody>
                    <CardMCConn dashboard={true} butchState={butchState} />
                </MainAreaBody>
            </MainArea>
        </>
    );

}



export default McConnect;
